<template>
  <div>
    <ServicesCard
      :cardHeadline="houseName ? `Saker bygg ${houseName}` : 'Prosjekt saker'"
      v-model="services"
      @click="click"
    ></ServicesCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { ServicesCardObject } from "@/types/interface";

import ServicesCard from "@/components/shared/cards/ServicesCard.vue";
import { count } from "@/helpers/countTasks";
import { countObject } from "@/types/tasksInterface";

export default Vue.extend({
  name: "ProjectShortcuts",
  props: {
    projectId: {
      type: Number,
    },
    houseName: {
      type: String,
    },
  },
  data() {
    return {
      count: {} as countObject,
    };
  },

  mounted() {
    this.fetchData();
    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  methods: {
    ...mapActions({
      setFilter: "tables/setFilter",
    }),
    fetchData() {
      count(
        this.profile.id,
        this.isTrysilhus,
        this.$route.params.id,
        this.$route.params.houseId
      ).then((x) => {
        this.count = x;
      });
    },
    click(item) {
      if (item.routeName) {
        var headers = [
          {
            filterValues: this.houseName,
            filterName: item.filterNameHouse,
          },
        ] as Array<any>;

        if (this.projectId) {
          headers.push({
            filterValues: [this.projectId],
            filterName: item.filterNameProject,
          });
        }

        var filter = {
          showAll: false,
          headers: headers,
        };

        this.setFilter(filter);
        this.$router.push({ name: item.routeName });
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
    }),
    services(): Array<ServicesCardObject> {
      const services = [
        {
          icon: "mdi-clipboard-alert-outline",
          title: "Reklamasjoner",
          routeName: "Complaints",
          filterNameProject: "projectOid",
          filterNameHouse: "projSectionApartNum",
          count: this.count.complaints,
        },
        {
          icon: "mdi-hammer-wrench",
          title: "Tiltak",
          routeName: "Actions",
          filterNameProject: "projTable",
          filterNameHouse: "apartmentKey",
          count: this.count.actions,
        },
        {
          icon: "mdi-message-text-outline",
          title: "Henvendelser",
          routeName: "Requests",
          filterNameProject: "projectOid",
          filterNameHouse: "projSectionApartNum",
          count: this.count.enquiry,
        },
        {
          icon: "mdi-account-check-outline",
          title: "Egenkontroller",
          routeName: "Checkups",
          filterNameProject: "projectId",
          filterNameHouse: "houseNum",
          count: this.count.checkups,
        },
      ];

      if (this.isTrysilhus) {
        services.push({
          icon: "mdi-order-bool-ascending-variant",
          title: "Sjekklister",
          routeName: "Checklists",
          filterNameProject: "projTable",
          filterNameHouse: "houseName",
          count: this.count.checklists,
        });
      }

      return services;
    },
  },
  components: {
    ServicesCard,
  },
});
</script>
